'use client'

import {
    Spinner as BaseComponent,
    type SpinnerProps as BaseProps,
} from '@chakra-ui/react'
import React from 'react'

type Omitted = 'emptyColor' | 'speed' | 'thickness' | 'variant' | 'colorScheme'

type SpinnerProps = Omit<BaseProps, Omitted> & {
    label: string
    /**
     * @default 'sm'
     */
    size?: 'sm' | 'lg'
}

export const Spinner = ({ size, ...props }: SpinnerProps) => (
    <BaseComponent
        emptyColor={size === 'lg' ? 'neutral.300' : 'white'}
        size={size}
        {...props}
    />
)
